/*
 * lu-variant-gallery.js (LU VG): product gallery filtered by several variant options at once.
 * Data comes from snippets/lu-settings.liquid:
 *   window.luVG  = { mediaId: [value handles from the image alt tags] }
 *   window.luVGh = { option value: handle }
 * Alt text format: "#grosime_2mm #color_gold". An image shows only when every tag value is a selected
 * option value; images without tags always show. Works next to the theme's own "hide unselected variants'
 * media" (assets/product.js), it only adds the class lu-vg-hide. If anything fails, nothing stays hidden.
 */
(function () {
  'use strict';
  var MAP = window.luVG, H = window.luVGh || {};
  if (!MAP) return;

  function handle(v) {
    if (Object.prototype.hasOwnProperty.call(H, v)) return H[v];
    return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function picker(wrap) {
    var list = wrap.querySelectorAll('variant-selects, variant-radios');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('product-add-to-cart-sticky') && list[i].querySelector('fieldset')) return list[i];
    }
    return null;
  }

  function selected(sel) {
    var cur = {}, n = 0;
    sel.querySelectorAll('fieldset').forEach(function (fs) {
      var s = fs.querySelector('select');
      if (s) { cur[handle(s.value)] = 1; n++; return; }
      var r = fs.querySelector('input[type="radio"]:checked');
      if (r) { cur[handle(r.value)] = 1; n++; }
    });
    return n ? cur : null;
  }

  function mediaId(el) {
    var raw = el.getAttribute('data-media-id') || el.id || '';
    var m = raw.match(/(\d+)$/);
    return m ? m[1] : null;
  }

  function showAll(wrap) {
    wrap.querySelectorAll('.lu-vg-hide').forEach(function (el) { el.classList.remove('lu-vg-hide'); });
  }

  function apply(wrap) {
    var sel = picker(wrap);
    var cur = sel && selected(sel);
    if (!cur) { showAll(wrap); return; }
    var slides = wrap.querySelectorAll('.product-images__slide, .product-thumbnail');
    var plan = [], visible = 0;
    slides.forEach(function (el) {
      var id = mediaId(el), tags = id && MAP[id], show = true;
      if (tags) {
        for (var i = 0; i < tags.length; i++) {
          if (!cur[tags[i]]) { show = false; break; }
        }
      }
      if (show && tags && el.classList.contains('product-images__slide')) visible++;
      plan.push([el, show]);
    });
    /* safety: if the selection matches no tagged image at all, do not filter */
    if (!visible) { showAll(wrap); return; }
    var changed = false;
    plan.forEach(function (p) {
      if (p[0].classList.contains('lu-vg-hide') === p[1]) {
        p[0].classList.toggle('lu-vg-hide', !p[1]);
        changed = true;
      }
    });
    if (!changed) return;
    var ps = wrap.querySelector('product-slider');
    if (ps) {
      setTimeout(function () {
        try {
          if (typeof ps.onPaginationResize === 'function') ps.onPaginationResize();
          ps.scrollTo({ left: 0 });
        } catch (e) {}
      }, 60);
    }
  }

  function run() {
    document.querySelectorAll('.thb-product-detail').forEach(function (wrap) {
      try { apply(wrap); } catch (e) { showAll(wrap); }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) {
      setTimeout(run, 0);
    }
  });
  document.addEventListener('shopify:section:load', run);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
